// extracted by mini-css-extract-plugin
module.exports = {"container":"WindowBox__container___BMgpB","topBackground":"WindowBox__topBackground___2leby","closeSvg":"WindowBox__closeSvg___3iWui"};